export default __webpack_public_path__ + "static/media/Location_Sachsen.c278e16f.svg";